import {get, on, val} from '../util';

export default class {
    static init = () => {
        init();
    }
}

function addDays(dateStr: string, days: number): string {
    let d = new Date(dateStr + 'T00:00:00');
    d.setDate(d.getDate() + days);
    return d.toISOString().slice(0, 10);
}

function init() {
    get_values_from_date();

    on('change','[name="date"]',get_values_from_date);

    on('click','.js-date-back',() => {
        let input = document.querySelector('[name="date"]') as HTMLInputElement;
        if(input) {
            input.value = addDays(input.value, -1);
            input.dispatchEvent(new Event('change'));
        }
    });

    on('click','.js-date-forward',() => {
        let input = document.querySelector('[name="date"]') as HTMLInputElement;
        if(input) {
            input.value = addDays(input.value, 1);
            input.dispatchEvent(new Event('change'));
        }
    });
}

function get_values_from_date() {
    let date = document.querySelector('#frm-submitForm [name="date"]') as HTMLInputElement;
    if(date) {
        // Phase 183 (UX-02, D-08/D-10): show skeleton shimmer before fetch, hide after.
        // Toggle the OUTER per-instance container by id — NOT the bare .ksat-skeleton-group
        // class, which is ambiguous: the shared ask-modal renders a second copy on every
        // show_header page (WR-01/WR-03). The container carries the `hidden` attribute in
        // Home/submit.latte; toggling the inner group would be collapsed by the hidden ancestor.
        const skel = document.getElementById('submit-skeleton-container');
        if (skel) skel.hidden = false;
        get('?do=getValuesFromDate',{
            date: date.value
        },(data : any) => {
            val('[name="alc"]',data.alc);
            val('[name="weight"]',data.weight);
            val('[name="waist"]',data.waist);
            val('[name="steps"]',data.steps);
            val('[name="hours"]',data.hours);
            val('[name="minutes"]',data.minutes);
            val('[name="seconds"]',data.seconds);
            val('[name="miles"]',data.miles);
            val('[name="kcal"]',data.kcal);
            // Hide skeleton after data populates
            if (skel) skel.hidden = true;
        });
    }
}
